import React from "react";
import { useInView } from "react-intersection-observer";
import Landing from "../components/Landing";
import Initiatives from "../components/Initiatives";
import BlogListing from "../components/BlogListing";
import ContactForm from "../components/ContactForm";
import space from "../assets/Daji Maharj.mp4";
import "../css/home.css";

export default function Home() {
  const { ref, inView } = useInView({
    triggerOnce: true, // Trigger only once when the video enters the viewport
    threshold: 0.1, // Load video when 10% of it is in view
  });
  // console.log("Is in view:", inView);  Logs true or false based on visibility

  return (
    <>

      <div className="video-container" ref={ref}>
        {inView ? (
          <video src={space} type="video/mp4" autoPlay loop muted>
            Sorry, your browser doesn't support videos.
          </video>
        ) : (
          <p>Loading...</p>
        )}
        <div className="typewriter">
          <h2>श्रीसद्गुरू दाजीमहाराज संस्थान, धनगर टाकळी...</h2>
        </div>
      </div>

      <Landing />
      <Initiatives />
      <BlogListing limit={4} />
      <ContactForm />
    </>
  );
}